module.exports = __webpack_public_path__ + "app-static/img/rhd.124afefc.png";